import { format, parse } from 'date-fns';

import {
  ConfirmedProjectSubscriptionRequest,
  SubscriptionRequest,
} from '@/types/subscriptions/request';
import { User } from '@/types/user';

export function normalizeCreatePayload(values: SubscriptionRequest) {
  const params = { ...values };
  if (values.projectClassId === 0) {
    params.projectClassId = null;
  }

  if (values.projectClassId && values.projectClassId > 0) {
    delete params.billingContactId;
    delete params.contactId;
  }

  const users = values.users.map((user, key) => ({
    ...user,
    key,
    id: user.id || undefined,
    isEmailConfirmed: undefined,
  }));

  return {
    ...params,
    startsOn: normalizeStartsOn(values.startsOn),
    users,
  };
}

export function normalizeSubscriptionRequestUpdatePayload(
  values: SubscriptionRequest,
  snapshots: {
    contactId?: SubscriptionRequest['contactId'];
    billingContactId?: SubscriptionRequest['billingContactId'];
  },
): SubscriptionRequest {
  // See https://github.com/globis-org/glopla-dev-portal/issues/79#issuecomment-415256233
  const normalizedValues = { ...values };
  const { contactId, billingContactId } = snapshots;

  // 更新時に住所が変更されてない時はパラメータから削る
  if (contactId !== 0 && contactId === values.contactId) {
    delete normalizedValues.contactId;
  }
  if (billingContactId !== 0 && billingContactId === values.billingContactId) {
    delete normalizedValues.billingContactId;
  }

  if (values.projectClassId === 0) {
    normalizedValues.projectClassId = null;
  }

  if (normalizedValues.projectClassId) {
    delete normalizedValues.billingNote;
  }

  return {
    ...normalizedValues,
    startsOn: normalizeStartsOn(values.startsOn),
    users: normalizeUsers(values.users),
  };
}

export function normalizeConfirmedProjectSubscriptionPayload(
  values: ConfirmedProjectSubscriptionRequest,
) {
  return {
    ...values,
    users: normalizeUsers(values.users),
  };
}

// back-end accepts starts_on with a character string of yyyy-mm-dd
export function normalizeStartsOn(date: string) {
  if (date.match(/\d{2}-\d{2}-\d{4}/)) {
    // firefox, safari で対応していない日付形式
    return format(parse(date, 'MM-dd-yyyy', new Date()), 'yyyy-MM-dd');
  }
  return date;
}

function normalizeUsers(users: User[]) {
  return users.map((user, key) => ({
    ...user,
    key,
    id: user.id || undefined,
    isEmailConfirmed: undefined,
  }));
}
